// extracted by mini-css-extract-plugin
module.exports = {"input":"search_input__uN2Uv","whiteinput":"search_whiteinput__vBSlT"};